import { WearableModalType } from "../types"
import WearableContentInfo from "../WearableContentInfo"

type WearableOptionDisconnectInfoProps = {
   onClickManualSelection: () => void
}

const WearableOptionDisconnectInfo = ({
   onClickManualSelection,
}: WearableOptionDisconnectInfoProps) => {
   return (
      <WearableContentInfo
         type={WearableModalType.OPTIONS}
         description={
            <div className="wearable-content-info__options-description">
               <span>Alternative method</span>
               <br />
               <span
                  className="wearable-content-info__options-description--clickable"
                  onClick={onClickManualSelection}
               >
                  Manually select a new ReassureBand
               </span>
            </div>
         }
      />
   )
}

export default WearableOptionDisconnectInfo
